var AsyncRequestManager = function () {
    return {
        renderAsyncRequest: function (url, queryParameters, domElementToChange, replaceContent, language = "en") {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: { language: language },
                success: function (data) {
                    if (domElementToChange != null) {
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }                          
                    }
                    $("#mi-corpo-elcacolos-loading-img").css("display", "none");

                }
            });
        },

        
        renderAsyncRequestProductListing: function (url, queryParameters, domElementToChange, replaceContent, language = "en", technologyFilter = "", fileButtonLabel = "",
            fileButtonCss = "", linkButtonLabel = "", linkButtonCss = "", linkButtonPath = "") {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: {
                    language: language, technologyFilter: technologyFilter, fileButtonLabel: fileButtonLabel, fileButtonCss: fileButtonCss, linkButtonLabel: linkButtonLabel,
                    linkButtonCss: linkButtonCss, linkButtonPath: linkButtonPath },
                success: function (data) {
                    if (domElementToChange != null) {
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                }
            });
        },

        renderAsyncRequestProductListingForApplications: function (url, queryParameters, domElementToChange, replaceContent, language = "en", applicationsFilters = "", fileButtonLabel = "",
            fileButtonCss = "", linkButtonLabel = "", linkButtonCss = "", linkButtonPath = "", filterType = "") {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: {
                    language: language, applicationsFilters: applicationsFilters, fileButtonLabel: fileButtonLabel, fileButtonCss: fileButtonCss, linkButtonLabel: linkButtonLabel,
                    linkButtonCss: linkButtonCss, linkButtonPath: linkButtonPath, filterType: filterType
                },
                success: function (data) {
                    if (domElementToChange != null) {
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                }
            });
        },

        renderAsyncRequestProductListingForPackagingLayer: function (url, queryParameters, domElementToChange, replaceContent, language = "en", packagingLayerFilters = "", fileButtonLabel = "",
            fileButtonCss = "", linkButtonLabel = "", linkButtonCss = "", linkButtonPath = "", filterType = "") {
            $.ajax({
                url: url + queryParameters,
                dataType: 'html',
                data: {
                    language: language, packagingLayerFilters: packagingLayerFilters, fileButtonLabel: fileButtonLabel, fileButtonCss: fileButtonCss, linkButtonLabel: linkButtonLabel,
                    linkButtonCss: linkButtonCss, linkButtonPath: linkButtonPath, filterType: filterType
                },
                success: function (data) {
                    if (domElementToChange != null) {
                        if (replaceContent) {
                            $(domElementToChange).replaceWith(data);
                        }
                        else {
                            $(domElementToChange).html(data);
                        }
                    }
                }
            });
        },

        renderSyncRequest: function (url, queryParameters, domElementToChange, language="en") {
            $.ajax({
                url: url + queryParameters,
                async: false,
                dataType: 'html',
                data: { language: language },
                success: function (data) {
                    if (domElementToChange != null) {
                        $(domElementToChange).html(data);
                    }
                }
            });
        }
    }
};